module.exports = __webpack_public_path__ + "img/5.d7dc3f39.jpg";